/*
The MIT License (MIT)

Copyright (c) 2012 Witold Szczerba

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

**********************************************************************************

Modified by Martin Cavoj, 2014

**********************************************************************************
*/
'use strict';

angular.module('casist.auth')

.factory('authService', ['$rootScope', 'httpBuffer', function($rootScope, httpBuffer) {
  return {
    /**
     * Call this function to indicate that authentication was successfull and trigger a
     * retry of all deferred requests.
     * @param data an optional argument to pass on to $broadcast which may be useful for
     * example if you need to pass through details of the user that was logged in
     */
    loginConfirmed: function(data, configUpdater) {
      var updater = configUpdater || function(config) {return config;};
      $rootScope.$broadcast('event:auth-loginConfirmed', data);
      httpBuffer.retryAll(updater);
    },

    tokenConfirmed: function(configUpdater) {
      var updater = configUpdater || function(config) {return config;};
      $rootScope.$broadcast('event:auth-tokenConfirmed');
      httpBuffer.retryAll(updater);
    },

    /**
     * Call this function to indicate that authentication should not proceed.
     * All deferred requests will be abandoned or rejected (if reason is provided).
     * @param data an optional argument to pass on to $broadcast.
     * @param reason if provided, the requests are rejected; abandoned otherwise.
     */
    loginCancelled: function(data, reason) {
      httpBuffer.rejectAll(reason);
      $rootScope.$broadcast('event:auth-loginCancelled', data);
    }
  };
}])

/**
 * $http interceptor.
 * On 401 response (without 'ignoreAuthModule' option) stores the request
 * and broadcasts 'event:angular-auth-loginRequired'.
 */
.config(['$httpProvider', function($httpProvider) {
  $httpProvider.interceptors.push(['$rootScope', '$q', 'httpBuffer', function($rootScope, $q, httpBuffer) {
    return {
      responseError: function(rejection) {
        if (rejection.status === 401 && !rejection.config.ignoreAuthModule) {
          var deferred = $q.defer();
          httpBuffer.rejectAll();
          $rootScope.$broadcast('event:auth-loginRequired', rejection);
          return deferred.promise;
        } else if (rejection.status == 403 && !rejection.config.ignoreAuthModule && rejection.data.code == "token_not_valid") {
          var deferred = $q.defer();
          httpBuffer.append(rejection.config, deferred);
          $rootScope.$broadcast('event:auth-tokenExpired', rejection);
          return deferred.promise;
        }
        // otherwise, default behaviour
        return $q.reject(rejection);
      }
    };
  }]);
}]);

/**
 * Private module, a utility, required internally by 'http-auth-interceptor'.
 */
angular.module('OAuthHTTPInterceptor-buffer', [])

.factory('httpBuffer', ['$injector', function($injector) {
  /** Holds all the requests, so they can be re-requested in future. */
  var buffer = [];

  /** Service initialized later because of circular dependency problem. */
  var $http;

  function retryHttpRequest(config, deferred) {
    function successCallback(response) {
      deferred.resolve(response);
    }
    function errorCallback(response) {
      deferred.reject(response);
    }
    $http = $http || $injector.get('$http');
    $http(config).then(successCallback, errorCallback);
  }

  return {
    /**
     * Appends HTTP request configuration object with deferred response attached to buffer.
     */
    append: function(config, deferred) {
      buffer.push({
        config: config,
        deferred: deferred
      });
    },

    /**
     * Abandon or reject (if reason provided) all the buffered requests.
     */
    rejectAll: function(reason) {
      if (reason) {
        for (var i = 0; i < buffer.length; ++i) {
          buffer[i].deferred.reject(reason);
        }
      }
      buffer = [];
    },

    /**
     * Retries all the buffered requests clears the buffer.
     */
    retryAll: function(updater) {
      for (var i = 0; i < buffer.length; ++i) {
        retryHttpRequest(updater(buffer[i].config), buffer[i].deferred);
      }
      buffer = [];
    }
  };
}]);
